import { useLatestEntity } from '@domain-group/react-hooks'

import { baseURL } from '@functions/api'

import useSelector from '@hooks/useSelector'

import type { SmsLogModel } from '@models/types'

export const generateUrls = (smsLog: Partial<SmsLogModel> = {}) => ({
  smsLogsIndexUrl: '#/systemManager/smsLogs',
  exportSmsLog: `${baseURL}/sms_logs/${smsLog.id}/export.json`,
})

function useSmsLog(initEntity: Partial<SmsLogModel> = {}) {
  // @ts-expect-error TS2322
  const { entity: smsLog }: { entity: SmsLogModel} = useLatestEntity(initEntity, 'smsLogs')

  const { loading } = useSelector(reduxState => reduxState.smsLogs)

  return {
    smsLog,
    loading,
    urls: generateUrls(smsLog),
  }
}

export default useSmsLog
